// extracted by mini-css-extract-plugin
export var label = "_b4-1";
export var reminder = "_b4-0";